module.exports = __webpack_public_path__ + "src/assets/img/chip-500.12c4d09c.svg";